module.exports = __webpack_public_path__ + "static/media/map-sample.ab5c5e3a.png";